import { Button, Typography } from '@/components/atoms';
import { LogoHeader } from '@/components/molecules/header/LogoHeader';
import { DT_SCREEN } from '@/core/constants/dynatraceScreens';
import { useCatalogDynatraceView } from '@/core/hooks/useCatalogDynatraceView';
import { useTranslation, useUIColors } from '@/core/hooks';
import { useAppStore } from '@/core/stores/appStore';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import MailCheck from '@assets/images/svg/mail-check.svg';
import { router } from 'expo-router';

export function ServiceRequestSuccessScreen() {
    useCatalogDynatraceView(
        DT_SCREEN.SERVICE_REQUEST_SUCCESS,
        'service_request_success_viewed',
        true,
    );
    const { t } = useTranslation();
    const colors = useUIColors();
    const isAuthenticated = useAppStore((state) => state.auth.isAuthenticated);

    // dismissTo (not replace): when the list is already underneath
    // ([list, success] after create's replace), replace would stack a second
    // list copy and back would need two presses. dismissTo pops back to the
    // existing one, and falls back to replace when it isn't in the stack.
    const handleBack = () => {
        if (isAuthenticated) {
            router.dismissTo('/service-request' as any);
        } else {
            router.dismissTo('/welcome' as any);
        }
    };

    return (
        <View style={[styles.container, { backgroundColor: colors.backgroundLevel1 }]}>
            <LogoHeader hideLogo showLanguageSwitch={false} onBackPress={handleBack} />
            <View style={styles.content}>
                <MailCheck width={160} height={160} />
                <Typography variant="title1" color="primary" style={styles.title}>
                    {t('support.successTitle')}
                </Typography>
                <Typography variant="body" color="tertiary" style={styles.subtitle}>
                    {t('support.successSubtitle')}
                </Typography>
            </View>
            <View style={styles.footer}>
                <Button
                    title={t('common.ok')}
                    fullWidth
                    variant="primary"
                    onPress={handleBack}
                />
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: { flex: 1 },
    content: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 24,
        gap: 12,
    },
    title: {
        textAlign: 'center',
    },
    subtitle: {
        textAlign: 'center',
    },
    footer: {
        paddingHorizontal: 24,
        paddingBottom: 32,
    },
});


